import Vue from 'vue';
import KlarnaPayment from './components/KlarnaPayment';

Vue.component('klarna-payments', KlarnaPayment);



// WEBPACK FOOTER //
// ./src/main.js